<template>
  <div>
    <!--背景图片-->
    <div style="position:relative;">
      <img alt="" src="../../../../assets/img/resume/个人简历背景-不带图标1.png" style="height: 250px; width: 100%; ">
      <div style="position:absolute; top:100px; left: 38%">
        <div style=" margin: 0 auto;">
          <img alt="" src="../../../../assets/img/resume/个人简历图标-工作成就-2.png"  style="height: 80px;">
        </div>
      </div>
    </div>

    <div style="background-color: #FFF;">

      <div style="height: 30px">
        <span class="bsicInfoTitle1">经销商:</span><span>{{orgName}}</span><span
              class="bsicInfoTitle1">职位:</span><span>{{jobName}}</span>
      </div>
      <!--关键管理岗补充信息-->
      <div>
<!--        <div style="width: 98%; margin:0 auto; ">-->
<!--          <el-card style="border-color: #2763af;">-->
<!--            <div slot="header">-->
<!--              <p>-->
<!--                <em class="keyManagement"></em>-->
<!--                <span class="bsicInfo">关键管理岗补充信息</span>-->
<!--              </p>-->
<!--  -->
<!--            </div>-->
<!--            <div>-->
<!--              <el-form label-position="top" :data="dataForm" :rules="dataListRules" :model="dataForm"-->
<!--                       ref="dataForm">-->
<!--                <el-row>-->
<!--                  <el-col :span="6">-->
<!--                    <el-form-item :label="$t('talentpool.jobApplication')" prop="managerialWorkingYears">-->
<!--                      <el-select v-model="dataForm.managerialWorkingYears"-->
<!--                                 clearable-->
<!--                                 :placeholder="$t('talentpool.jobApplication')">-->
<!--                        <el-option v-for="(item,index) in jobApplication"-->
<!--                                   :key="index"-->
<!--                                   :label="item.name"-->
<!--                                   :value="item.code">-->
<!--                        </el-option>-->
<!--                      </el-select>-->
<!--                    </el-form-item>-->
<!--                  </el-col>-->
<!--  -->
<!--                  <el-col :span="6">-->
<!--                    <el-form-item :label="$t('talentpool.automotiveRelatedExperience')" prop="relatedWorkingYears" >-->
<!--                      <el-select v-model="dataForm.relatedWorkingYears"-->
<!--                                 clearable-->
<!--                                 :placeholder="$t('talentpool.automotiveRelatedExperience')">-->
<!--                        <el-option v-for="(item,index) in jobApplication"-->
<!--                                   :key="index"-->
<!--                                   :label="item.name"-->
<!--                                   :value="item.code">-->
<!--                        </el-option>-->
<!--                      </el-select>-->
<!--                    </el-form-item>-->
<!--                  </el-col>-->
<!--  -->
<!--                </el-row>-->
<!--  -->
<!--                <el-row>-->
<!--                  <el-col :span="24">-->
<!--                    <el-form-item :label="$t('talentpool.selectJobAutomotive')">-->
<!--                    </el-form-item>-->
<!--                    <el-input v-model="dataForm.awards"-->
<!--                              :placeholder="$t('talentpool.selectJobAutomotive')"></el-input>-->
<!--                  </el-col>-->
<!--                </el-row>-->
<!--  -->
<!--                <el-row>-->
<!--                  <el-col :span="24">-->
<!--                    <el-form-item :label="$t('talentpool.certifications')">-->
<!--                    </el-form-item>-->
<!--                    <el-input v-model="dataForm.certifications"-->
<!--                              :placeholder="$t('talentpool.certifications')"></el-input>-->
<!--                  </el-col>-->
<!--                </el-row>-->
<!--  -->
<!--                <el-row>-->
<!--                  <el-col :span="24">-->
<!--                    <el-form-item :label="$t('talentpool.activities')">-->
<!--                    </el-form-item>-->
<!--                    <el-input v-model="dataForm.activities"-->
<!--                              :placeholder="$t('talentpool.activities')"></el-input>-->
<!--                  </el-col>-->
<!--                </el-row>-->
<!--              </el-form>-->
<!--            </div>-->
<!--          </el-card>-->
<!--        </div>-->
<!--  -->
<!--        &lt;!&ndash;占位符&ndash;&gt;-->
<!--        <div style="height: 50px"></div>-->
      </div>
      <!--工作成就-->
      <div style="width: 98%; margin:0 auto; ">
        <el-card style="border-color: #2763af;">
          <div slot="header">
            <p>
              <em class="workAchievement"></em>
              <span class="bsicInfo">工作业绩</span>
            </p>

          </div>
          <div>
            <el-form label-position="top" :model="accomplishmentFrom" ref="accomplishmentFrom">
              <p>
                <span style="font-weight: 700;">以下填写内容将作为能力评估的重要参考，请如实填写:</span>
              </p>
              <div v-for="(itemWork,index) in accomplishmentFrom.accomplishment_list">
                <!--成就1 -->
<!--                <p>-->
<!--                  <span style="font-size: 20px; color: #1d68d4; font-weight: 700;">{{ itemWork.name }}</span>-->
<!--                </p>-->
                <p>
                  <span>{{ itemWork.content }}</span>
                </p>
                <el-row>
                  <el-row>
                    <el-col :span="24">
<!--                      <el-form-item label="成就">-->
<!--                      </el-form-item>-->
                    </el-col>
                    <el-form-item
                            :prop="'accomplishment_list.' + index + '.resultText'"
                            :rules="[{ required: true, message: '工作业绩不能为空',trigger: 'blur'},{ min: 50, max: 1500, message: '输入字符长度须在50~1500位字符之间', trigger: 'blur' }]">
                      <el-input v-model="itemWork.resultText" type="textarea" minlength="50" :maxlength="1500" show-word-limit :rows="4"
                                placeholder="请输入工作业绩（限输入50~1500字符)"></el-input>
                    </el-form-item>
                  </el-row>

                  <!--占位符-->
                  <div style="height: 50px"></div>

<!--                  <el-row>-->
<!--                    <el-col :span="24">-->
<!--                      <el-form-item label="行动">-->
<!--                      </el-form-item>-->
<!--                    </el-col>-->
<!--                    <el-input v-model="itemWork.action" type="textarea" :maxlength="500" show-word-limit :rows="4"-->
<!--                              placeholder="请输入个人评价（限输入500字)"></el-input>-->
<!--                  </el-row>-->
<!--                  &lt;!&ndash;占位符&ndash;&gt;-->
<!--                  <div style="height: 50px"></div>-->

<!--                  <el-row>-->
<!--                    <el-col :span="24">-->
<!--                      <el-form-item label="结果">-->
<!--                      </el-form-item>-->
<!--                    </el-col>-->
<!--                    <el-input v-model="itemWork.result" type="textarea" :maxlength="500" show-word-limit :rows="4"-->
<!--                              placeholder="请输入个人评价（限输入500字)"></el-input>-->
<!--                  </el-row>-->
<!--                  &lt;!&ndash;占位符&ndash;&gt;-->
<!--                  <div style="height: 50px"></div>-->

                </el-row>
              </div>

            </el-form>
          </div>
        </el-card>
      </div>

      <!--占位符-->
      <div style="height: 50px"></div>

      <div align="center">
        <el-button @click="onReturnPage">返回上一页</el-button>
        <el-button type="primary" @click="onSaveWork(1)">保存并提交</el-button>
        <el-button type="primary" @click="onSaveWork(0)">保存</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>

      <!--占位符-->
      <div style="height: 50px"></div>

    </div>
  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  // 例如：import 《组件名称》 from '《组件路径》';

  export default {
// import引入的组件需要注入到对象中才能使用
    components: {},
    props: [],
    data() {
      let _this = this
      return {

        userId: this.$route.query.userId,
        jobName: this.$route.query.jobName,
        orgName: this.$route.query.orgName,
        recruitmentId:this.$route.query.recruitmentId,
        isAssessmentListNew:this.$route.query.isAssessmentListNew,


        radio: 3,
        dataForm: {
          awards: '',
          certifications: '',
          activities: '',
          relatedWorkingYears:'',
          managerialWorkingYears:'',

        },
        accomplishmentFrom: {
          accomplishment_list: [
            {
              content: "描述",
              result: "结果1s222",
              resultText: "结果1 222",
              jobId: "11",
              createTime: "2020-09-18 15:06:35",
              name: "成就一",
              accomplishmentId: "1",
              action: "行动1",
              id: "1",
              placeholder: "提示文字",
              situation: "环境1",
            }
          ]
        },
        // 行业经验
        jobApplication: _this.enums['jobApplication'],

        // 数据验证
        dataListRules: {

          managerialWorkingYears: [
            {required: true, message: '与申请岗位相关管理经验', trigger: 'change'}
          ],
          relatedWorkingYears: [
            {required: true, message: '汽车行业相关经验', trigger: 'change'}
          ],
        }
      }
    },
// 监听属性 类似于data概念
    computed: {},
// 监控data中的数据变化
    watch: {},
// 生命周期 - 创建完成（可以访问当前this实例）
    created() {
      console.log('created')
    },
// 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.getInfo()
    },
    beforeCreate() {
      console.log('beforeCreate')
    }, // 生命周期 - 创建之前
    beforeMount() {
      console.log('beforeMount')
    }, // 生命周期 - 挂载之前
    beforeUpdate() {
      console.log('beforeUpdate')
    }, // 生命周期 - 更新之前
    updated() {
      console.log('updated')
    }, // 生命周期 - 更新之后
    beforeDestroy() {
      console.log('beforeDestroy')
    }, // 生命周期 - 销毁之前
    destroyed() {
      console.log('destroyed')
    }, // 生命周期 - 销毁完成
    activated() {
      console.log('activated')
    },
// 方法集合
    methods: {
      // 返回上一页
      onReturnPage: function () {
        this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$emit('onShowModer', 'showResumeEditInfo')
        }).catch((err) => {
          console.log(err)
        })

        // document.body.scrollTop = document.documentElement.scrollTop = 0
      },
      // 获取信息
      getInfo() {
        this.$nextTick(() => {
          if (this.$route.query.recruitmentId) {
            this.$request
              .post('/acdc/candidate/queryCandidate', {
                recruitmentId: this.$route.query.recruitmentId,
              })
              .then((res, total, code, data) => {
                this.dataForm = data.data
                this.accomplishmentFrom.accomplishment_list = data.data.accomplishmentDTOList
                for(let i=0; i<this.accomplishmentFrom.accomplishment_list.length; i++){
                  this.$set(this.accomplishmentFrom.accomplishment_list[i],'resultText',this.preText(this.accomplishmentFrom.accomplishment_list[i].result))
                }

                console.log(this.dataForm)
              })
              .catch((err) => {
                console.log(err)
              })
          } else {
            this.dataForm = {}
          }
        })
      },

      // 将文本域的文本进行处理让文本保存换行空格形式，传递给后端
      preHTML (pretext) {
        return pretext.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp;')
      },
      // 将文本域的文本进行处理让文本保存换行空格形式，传递给后端
      preText (pretext) {
        if(pretext !== null){
          while(pretext.indexOf('<br/>') !== -1){
            pretext = pretext.replace('<br/>', '\r\n')
          }
          while(pretext.indexOf('&nbsp;') !== -1){
            pretext = pretext.replace('&nbsp;', ' ')
          }
          return pretext
        }else {
          return pretext
        }
      },
      // 保存工作成就
      onSaveWork(isSubmit){
        //isSubmit   1：是  0 ：否
        this.dataForm.accomplishmentDTOList = this.accomplishmentFrom.accomplishment_list
        this.dataForm.isSubmit = isSubmit

        let isWorkBookean = true
        let msg = '工作业绩有未填项，不能保存'

        // 工作成就转化html
        for(let i=0; i<this.accomplishmentFrom.accomplishment_list.length; i++){
          if(this.accomplishmentFrom.accomplishment_list[i].resultText !== null && this.accomplishmentFrom.accomplishment_list[i].resultText.length > 0){
            this.accomplishmentFrom.accomplishment_list[i].result = this.preHTML(this.accomplishmentFrom.accomplishment_list[i].resultText)
          }else {
            isWorkBookean = false
            // msg += this.accomplishmentFrom.accomplishment_list[i].name + ' 不能为空'+'<br/>'
          }
        }

        this.$refs['accomplishmentFrom'].validate((valid) => {
          if (valid) {
            console.log('accomplishmentFrom submit!!');
          } else {

            isWorkBookean = false
          }
        })

        if(isWorkBookean){
          this.$request
            .post('/acdc/candidate/updateCandidate', this.dataForm)
            .then((res, total, code, data) => {
              console.log(this.data)
              if(data.code === 1){
                console.log('data.code')
                this.$message({
                  message: this.$t('prompt.success'),
                  type: 'success',
                  duration: 500,
                })
                this.tabRemove()
                this.barkInfo()
              }else {
                this.$message.error(data.msg)
              }

            })
            .catch((err) => {
              console.log(err)
            })
        }else {
          // this.$message.error(msg)
          // 注释 不用了 直接在输入框下面提示
          // this.$message({
          //   dangerouslyUseHTMLString: true,
          //   message: msg,
          //   type:"error"
          // });
        }

      },


      // 取消按钮
      cancel () {
        this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.tabRemove()
          this.barkInfo()
        }).catch((err) => {
          console.log(err)
        })
      },

      // 返回页面
      barkInfo(){
        if(this.isAssessmentListNew === '0'){
          this.$router.push({
            name: 'acdc-resume-resumePDF',
            query: {
              userId: this.userId,
              jobName: this.jobName,
              orgName: this.orgName,
              recruitmentId:this.recruitmentId,
              isAssessmentListNew:this.isAssessmentListNew,
            }
          })
        }
        // 调用我的评估中心初始化方法
        this.$eventHub.$emit('assessmentListNew', '')
      },

      // 删除当前页面
      tabRemove () {
        let tabName = this.$store.state.contentTabsActiveName
        if (tabName === 'home') {
          return false
        }
        this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
        if (this.$store.state.contentTabs.length <= 0) {
          this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
          return false
        }
        // 当前选中tab被删除
        if (tabName === this.$store.state.contentTabsActiveName) {
          this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
        }
      },
    }
  }
</script>
<style lang='scss' scoped>
  // @import url(); 引入公共css类

  .picon {
    transform: translateX(-6%);
  }

  .bsicInfoTitle1 {
    text-align: center;
    display: inline-block;
    font-weight: 700;
    padding: 0 0.5%;
  }

  .bsicInfo {
    text-align: center;
    display: inline-block;
    color: #8fa3c6;
    font-size: 20px;
    padding: 0 0.5%;
  }

  .img-div {
    text-align: center;
    width: 142px;
  }


  .keyManagement {
    display: inline-block;
    width: 25px;
    height: 25px;
    background-image: url("../../../../assets/img/resume/工作成就-关键管理岗补充信息-图标.png");
    background-size: 100% 100%;
    vertical-align: bottom;
  }

  .workAchievement {
    display: inline-block;
    width: 25px;
    height: 25px;
    background-image: url("../../../../assets/img/resume/工作成就-工作成就-图标-2.png");
    background-size: 100% 100%;
    vertical-align: bottom;
  }


  ::v-deep .el-textarea .el-input__count {
    bottom: -26px !important;
  }

  ::v-deep .el-form-item {
     width: 100% !important;
  }

</style>
